import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const AuditTypeForm = forwardRef(({type, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={type}
      type="type"
      fieldsComponent={(props) => <Fields {...props}/>}
      onSave={({id, title, introduction, show_exceeded}) => services.auditType.type.saveType({id, title, introduction, show_exceeded})}
      onSaved={onSaved}
    />
  );
});

export default AuditTypeForm;
